<template>
  <v-container fluid class="px-15 pb-10 pt-4">
  
    <v-row class="ma-0 mt-5 mb-4">
      <v-col class="pa-0 my-4">
        <div style="font-family: 'montserrat-bold'; font-size: 32px; color: #000000;">
          Tipos de documentos KYC
        </div>
        <div style="font-family: 'montserrat-regular'; font-size: 14px;">
          Administra el catálogo de documentos requeridos para validación KYC.
        </div>
      </v-col>
    </v-row>

    <!-- Botón para abrir el diálogo -->
    <v-row class="mb-6">
      <v-col cols="12" class="d-flex justify-end">
        <v-btn color="black" style="font-family: 'montserrat-bold';" dark rounded @click="dialog = true">
          Crear documento
        </v-btn>
      </v-col>
    </v-row>

    <!-- Tabla de documentos existentes -->
    <v-data-table :items="documents" :loading="loading" hide-default-header>
      <template v-slot:header>
        <thead style="background-color: #f9fafd;">
          <tr>
            <th class="header__title left">Nombre</th>
            <th class="header__title center">Producto</th>
            <th class="header__title center">Categoría</th>
            <th class="header__title center">Tipo de input</th>
            <th class="header__title center">Requerido</th>
            <th class="header__title center">Descripción</th>
            <th class="header__title right">Acciones</th>
          </tr>
        </thead>
      </template>
      <template v-slot:body="{ items }">
        <tbody>
          <tr v-for="doc in items" :key="doc.sId || doc.id">
            <td class="table__item">{{ doc.nombre }}</td>
            <td class="table__item center">{{ doc.flujo || '-' }}</td>
            <td class="table__item center">{{ doc.categoria }}</td>
            <td class="table__item center">{{ doc.tipo_input }}</td>
            <td class="table__item center">
              <v-chip small outlined :color="doc.es_requerido ? 'green' : 'grey'">
                {{ doc.es_requerido ? 'Sí' : 'No' }}
              </v-chip>
            </td>
            <td class="table__item center">{{ doc.descripcion || '-' }}</td>
            <td class="table__item right">
              <v-btn icon small @click="editarDocumento(doc)">
                <v-icon color="black">mdi-pencil</v-icon>
              </v-btn>
              <v-btn icon small @click="abrirDialogoEliminar(doc)">
                <v-icon color="red">mdi-delete</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>

    <!-- Diálogo para crear documento -->
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card class="pa-6" style="border-radius: 20px;">
        <h2 class="text-center mb-6" style="font-family: 'montserrat-bold'; color: #000;">Crear nuevo documento KYC</h2>
        <v-text-field
          v-model="nuevo.nombre"
          label="Nombre"
          style="border-radius: 10px;"
          outlined
          dense
          class="mb-3"
        />
        <v-select
          v-model="nuevo.categoria"
          :items="categorias"
          label="Categoría"
          style="border-radius: 10px;"
          outlined
          dense
          class="mb-3"
        />
        <v-select
          v-model="nuevo.producto"
          :items="tipoDeProducto"
          label="Tipo de producto"
          style="border-radius: 10px;"
          outlined
          dense
          class="mb-3"
        />
        <v-select
          v-model="nuevo.tipo_input"
          :items="tiposInput"
          label="Tipo de input"
          style="border-radius: 10px;"
          outlined
          dense
          class="mb-3"
        />
        <v-text-field
          v-model="nuevo.descripcion"
          label="Descripción"
          style="border-radius: 10px;"
          outlined
          dense
          class="mb-3"
        />
        <v-switch
          v-model="nuevo.es_requerido"
          :label="nuevo.es_requerido ? 'Requerido: Sí' : 'Requerido: No'"
          class="mb-3 mt-0"
          dense
          inset
        />
        <v-file-input
          v-model="archivoEjemploFile"
          label="Ejemplo de documento (opcional)"
          accept=".pdf,.jpg,.png"
          outlined
          dense
          class="mb-6"
          prepend-icon="mdi-upload"
          show-size
        />
        <v-row>
          <v-col cols="6">
            <v-btn
              block
              color="grey lighten-2"
              @click="cerrarDialogo"
              style="color: black; border-radius: 12px;"
            >
              Cancelar
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn
              block
              color="black"
              dark
              @click="crearDocumento"
              :loading="isLoading"
              style="border-radius: 12px;"
            >
              Crear
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>

    <!-- Diálogo para editar documentos -->
    <v-dialog v-model="dialogEditar" v-if="dialogEditar" max-width="600px">
      <v-card class="pa-4" style="border-radius: 24px">
        <v-card-title class="text-h6 font-weight-bold">
          Editar documento KYC
        </v-card-title>

        <v-card-text>
          <v-text-field
            v-model="documentoSeleccionado.nombre"
            label="Nombre"
            outlined
            dense
          />

          <v-select
            v-model="documentoSeleccionado.categoria"
            :items="categorias"
            label="Categoría"
            outlined
            dense
          />

          <v-select
            v-model="documentoSeleccionado.flujo"
            :items="tipoDeProducto"
            label="Tipo de producto"
            outlined
            dense
          />

          <v-select
            v-model="documentoSeleccionado.tipo_input"
            :items="tiposInput"
            label="Tipo de input"
            outlined
            dense
          />

          <v-text-field
            v-model="documentoSeleccionado.descripcion"
            label="Descripción"
            outlined
            dense
          />

          <v-switch
            v-model="documentoSeleccionado.es_requerido"
            :label="documentoSeleccionado.es_requerido ? 'Requerido: Sí' : 'Requerido: No'"
            dense
            inset
            class="mt-0"
          />

          <v-row dense>
            <v-col cols="12">
              <v-card v-if="documentoSeleccionado.ejemplo_path && !removeEjemploActual" class="pa-3 d-flex align-center justify-space-between mb-3" outlined>
                <div class="d-flex flex-column">
                  <span style="font-weight: 600;">Documento ejemplo actual</span>
                </div>
                <div>
                  <v-btn icon @click="abrirDocumento(documentoSeleccionado.ejemplo_path)" target="_blank">
                    <v-icon color="primary">mdi-eye</v-icon>
                  </v-btn>
                  <v-btn icon @click="marcarParaEliminarEjemplo">
                    <v-icon color="red">mdi-delete</v-icon>
                  </v-btn>
                </div>
              </v-card>
              <v-alert
                v-if="removeEjemploActual && !archivoEjemplo"
                dense
                outlined
                type="warning"
                class="mb-3"
              >
                El documento ejemplo actual se eliminará al guardar.
              </v-alert>
              <v-file-input
                v-model="archivoEjemplo"
                :label="documentoSeleccionado.ejemplo_path && !removeEjemploActual ? 'Reemplazar documento ejemplo' : 'Subir documento ejemplo'"
                accept=".pdf,.jpg,.png"
                outlined
                dense
                prepend-icon="mdi-upload"
                show-size
              />
              <v-btn
                v-if="removeEjemploActual"
                text
                small
                color="grey darken-1"
                class="mt-1"
                @click="cancelarEliminarEjemplo"
              >
                Deshacer eliminación
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="justify-end">
          <v-btn text @click="dialogEditar = false">Cancelar</v-btn>
          <v-btn color="black" :loading="isLoading" dark @click="guardarCambios">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo para confirmar eliminación -->
    <v-dialog v-model="dialogEliminar" max-width="500px">
      <v-card class="pa-4" style="border-radius: 20px;">
        <v-card-title class="text-h6 font-weight-bold">
          Confirmar eliminación
        </v-card-title>
        <v-card-text>
          ¿Estás seguro de que deseas eliminar el documento "{{ documentoSeleccionado ? documentoSeleccionado.nombre : '' }}"?
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="cerrarDialogoEliminar">Cancelar</v-btn>
          <v-btn color="red" dark :loading="isDeleting" :disabled="isDeleting || !documentoSeleccionado" @click="eliminarDocumento">Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      loading: false,
      isLoading: false,
      isDeleting: false,
      dialogEditar: false,
      documentoSeleccionado: null,
      archivoEjemplo: null,
      removeEjemploActual: false,
      dialogEliminar: false,
      nuevo: {
        nombre: '',
        categoria: '',
        producto: '',
        tipo_input: '',
        descripcion: '',
        es_requerido: true,
      },
      archivoEjemploFile: null,
      categorias: ['Fiscal', 'Identidad', 'Legal', 'Bancario'],
      tiposInput: ['file', 'text'],
      tipoDeProducto: ['Divisas', 'Factoraje Cedente', 'Factoraje Deudor', 'Crédito Revolvente'],
      documents: []
    };
  },
  methods: {
    getKycDocuments() {
      this.loading = true;

      DB.get(`${URI}/api/v1/en/administrator/getKycDocuments`, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : ""
        }
      })
      .then((response) => {
        this.documents = response.data.documents;
      })
      .catch((error) => {
        this.mixError(error.response.data.message, error.response.status);
      })
      .finally(() => {
        this.loading = false;
      });
    },
    cerrarDialogo() {
      this.dialog = false;
      this.resetFormulario();
    },
    async crearDocumento() {
      try {
        this.isLoading = true;
        const formData = new FormData();
        formData.append('nombre', this.nuevo.nombre);
        formData.append('producto', this.nuevo.producto);
        formData.append('categoria', this.nuevo.categoria);
        formData.append('tipo_input', this.nuevo.tipo_input);
        formData.append('descripcion', this.nuevo.descripcion);
        formData.append('es_requerido', this.nuevo.es_requerido);
        if (this.archivoEjemploFile instanceof File) {
          formData.append('archivoEjemplo', this.archivoEjemploFile);
        }

        const response = await DB.post(
          `${URI}/api/v1/en/administrator/createKycDocument`,
          formData,
          {
            headers: {
              Authorization: this.$store.state.sToken ? `Bearer ${this.$store.state.sToken}` : "",
            }
          }
        );

        this.isLoading = false;
        this.mixSuccess(response.data.message || 'Documento creado correctamente');
        this.dialog = false;
        this.resetFormulario();
        this.getKycDocuments();
      } catch (error) {
        if (error.response?.data?.code) {
          this.$router.push("/welcome").catch(() => {});
        }
      } finally {
        this.isLoading = false;
      }
    },
    resetFormulario() {
      this.nuevo = {
        nombre: '',
        categoria: '',
        producto: '',
        tipo_input: '',
        descripcion: '',
        es_requerido: true,
      };
      this.archivoEjemploFile = null;
    },
    editarDocumento(doc) {
      this.documentoSeleccionado = { ...doc };
      this.archivoEjemplo = null;
      this.removeEjemploActual = false;
      this.dialogEditar = true;
    },
    marcarParaEliminarEjemplo() {
      this.removeEjemploActual = true;
    },
    cancelarEliminarEjemplo() {
      this.removeEjemploActual = false;
    },
    abrirDialogoEliminar(doc) {
      this.documentoSeleccionado = { ...doc };
      this.dialogEliminar = true;
    },
    cerrarDialogoEliminar() {
      this.dialogEliminar = false;
      this.documentoSeleccionado = null;
    },
    obtenerIdDocumento(doc) {
      if (!doc) {
        return null;
      }

      return doc.sId || doc.id || null;
    },
    guardarCambios() {
      const doc = this.documentoSeleccionado;
      const documentId = this.obtenerIdDocumento(doc);
      if (!documentId) {
        this.mixError('No se encontró el identificador del documento.');
        return;
      }

      this.isLoading = true;
      const formData = new FormData();
      formData.append('nombre', doc.nombre || '');
      formData.append('categoria', doc.categoria || '');
      formData.append('tipo_input', doc.tipo_input || '');
      formData.append('es_requerido', doc.es_requerido);
      formData.append('descripcion', doc.descripcion || '');
      formData.append('flujo', doc.flujo || '');
      formData.append('removeEjemplo', this.removeEjemploActual ? 'true' : 'false');

      if (this.archivoEjemplo instanceof File) {
        formData.append('archivoEjemplo', this.archivoEjemplo);
      }

      DB.put(
        `${URI}/api/v1/en/administrator/updateKycDocument/${documentId}`,
        formData,
        {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        }
      )
      .then((response) => {
        this.mixSuccess(response.data.message || 'Documento actualizado correctamente');
        this.dialogEditar = false;
        this.archivoEjemplo = null;
        this.removeEjemploActual = false;
        this.getKycDocuments();
      })
      .catch((error) => {
        this.mixError(error.response?.data?.message || 'No se pudo actualizar el documento', error.response?.status);
      })
      .finally(() => {
        this.isLoading = false;
      });
    },
    abrirDocumento(doc) {
      console.log('Abriendo documento:', doc);
      window.open(`${doc}`, '_blank');
    },
    eliminarDocumento() {
      const documentId = this.obtenerIdDocumento(this.documentoSeleccionado);
      if (!documentId) {
        this.mixError('No se encontró el identificador del documento.');
        return;
      }

      this.isDeleting = true;

      let payload = {
        documentId
      };

      DB.post(`${URI}/api/v1/en/administrator/deleteKycDocument`, payload, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : ""
        }
      })
      .then((response) => {
        this.mixSuccess(response.data.message || 'Documento eliminado correctamente');
        this.cerrarDialogoEliminar();
        this.getKycDocuments();
      })
      .catch((error) => {
        this.mixError(error.response.data.message, error.response.status);
      })
      .finally(() => {
        this.isDeleting = false;
      });
    }
  },
  mounted() {
    this.getKycDocuments();
  },
};
</script>

<style scoped>
</style>
